<template>
<div class="wrap_app">
    <p>根据证监会的要求，并保证您的合法权益，</p>
    <p>请仔细阅读以下协议：</p>
    <div class="box" v-for="item in list" @click="page(item)">{{ item.name }}</div>
    <div class="btn" @click="page('charge')">同意并支付</div>
</div>
</template>

<script>
import goldApi from '@/api/gold/detail.js'
import "@/utils/flexible";
export default {
    data() {
        return {
            list:[],
            tip:'网络原因，请稍后再试',
        };
    },
    created() {
        this.getlist();   
    },
    mounted() {
        
    },
    methods:{
        page(item){
            console.log(item);
            if(item == 'charge'){
                this.$srH5CallNativeMethodApp('call_agree_charge',{})
            }
            else if(item.kind == "image"){
                this.$srBrowserMedia(0,[{"type":"image","img_url": item.url}]);
            }
            else{
                this.$srH5CallNativeMethodApp('call_Native',{
                    kind: 'agreement_detail',
                    url:`/up/app/agreement_detail?kind=${item.kind}&id=${item.id}&month_price=${item.month_price||0}`,
                })
            }
        },
        async getlist() {
            let params = {
                type:'recharge',
            }
            let res = await goldApi.agreement(params);
            if(res.status == "success") {
                if (res.data.length === 0) {
                    alert(res.message||this.tip);
                }
                else{
                    this.list = res.data;
                }
            }
            else {
                alert(res.message||this.tip);
            }
        },
    }
}
</script>

<style lang="scss" scoped>
    @import "~@/assets/sass/global.scss";
    .wrap_app{
    display: flex;
    align-items: center;
    flex-direction: column;
    background: #F8F8F8;
    min-height: 100vh;
    padding: rem2(12px) rem2(0px);
    box-sizing: border-box;
    p{
        
        font-size: rem2(15px);
        color: #636363;
        text-align: center;
        line-height: 150%;
    }
    .btn{
        width: 100%;
        width: rem2(345px);
        height: rem2(44px);
        flex-shrink: 0;
        border-radius: 6px;
        background: #FE484A;

        color: #FFF;
        font-size: rem2(17px);
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: rem2(20px);
    }
    .box{
        width: rem2(345px);
        height: rem2(101.5px);
        flex-shrink: 0;
        color: #1D88D0;
        font-size: rem2(16px);
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: rem2(6px);
        background: #FFF;
        margin-top: rem2(12px);
    }
}
    
</style>